import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';
import { GenericSelect } from '../../components';


const PPWPeriodInput: InputWithSource = ({ input }) => <GenericSelect label={input.name} input={input} />;

PPWPeriodInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(PPWPeriodInput);
